export default __webpack_public_path__ + "static/media/Lato-Regular.9d883d54.ttf";